import { logFocusConnectionError, logSilentError, } from "@single-js/common/core/sql/actions";
import { of } from "rxjs";
import { makeActionCreator } from "worker/api/helpers";
import { backend } from "worker/net/backend";
const PROXY_SAGA_ID = "proxy-ping";
export const proxyPing = makeActionCreator({
    name: "proxyPing",
    handle(ctx) {
        return ctx.sagas.register(PROXY_SAGA_ID, (observer) => {
            let running = true;
            let timeoutId;
            let lastError = false;
            const emit = (action) => running && observer.next(action);
            const ping = () => {
                return backend
                    .ping()
                    .then(() => {
                    emit({
                        type: "PROXY_PING",
                        error: false,
                        payload: {},
                    });
                    lastError = false;
                })
                    .catch((err) => {
                    emit({
                        type: "PROXY_PING",
                        error: true,
                        payload: { message: err.toString() },
                    });
                    const msg = `Proxy ping failed: ${err.toString()}`;
                    // We want to focus the Connection tab on a ping error
                    // to alert the user that something is wrong, but only
                    // on the first error, if the ping last succeeded
                    // (otherwise, once the ping starts failing, we'd focus
                    // the tab every five seconds and the user wouldn't be
                    // able to close the bottom panel or check other tabs.)
                    if (lastError) {
                        emit(logSilentError(msg));
                    }
                    else {
                        emit(logFocusConnectionError(msg));
                    }
                    lastError = true;
                })
                    .finally(() => {
                    if (running) {
                        timeoutId = setTimeout(ping, 5000);
                    }
                });
            };
            ping();
            return () => {
                running = false;
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            };
        });
    },
});
export const proxyPingStop = makeActionCreator({
    name: "proxyPingStop",
    handle(ctx) {
        ctx.sagas.stop(PROXY_SAGA_ID);
        return of({
            type: "PROXY_PING_STOP",
            error: false,
            payload: {},
        });
    },
});
